import {createElement, PropTypes} from 'rlink-react';
import ShopItemTitle from 'rlink-shop/components/ShopItemTitle';
import BuyButton from 'rlink-shop/components/BuyButton';
import {ContentImg} from 'rlink-repos/content-components';
import ShopProvider from 'rlink-shop/service/base';
import shopStore from 'rlink-shop/store';
import {FluxStoreBoundComponent} from 'rlink-flux';
import {deepEquals} from 'rlink-utils/object';

export default class MoreInfoModal extends FluxStoreBoundComponent {
  getStore () {
    return shopStore;
  }

  getStateFromStore () {
    return shopStore.getFullProductState(this.props.shopItem.identifier);
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (!deepEquals(this.props, nextProps) || !deepEquals(this.state, nextState));
  }

  render () {
    let {css, productData, service, shopItem, ratingsBoard, onSale} = this.props;
    return (<div className={css['info-modal']}>
      <div className={css['modal-content']}>
        {shopItem.modalBackgroundPath && <ContentImg src={shopItem.modalBackgroundPath} />}
        <div className={css.details}>
          <div className={css['modal-title']}>{shopItem.modalTitle}</div>
          <ShopItemTitle
            css={css}
            title={shopItem.title}
            subtitle={shopItem.subtitle}
            wrap />
          <BuyButton
            css={css}
            isDisabled={shopItem.disable}
            identifier={shopItem.identifier}
            isPreorder={shopItem.preorder}
            purchaseIdentifier={shopItem.purchaseIdentifier}
            productData={productData}
            service={service}
            purchaseModalContent={productData.purchaseModalContent}
            ratingsBoard={ratingsBoard} />
          <div className={css.body}
            dangerouslySetInnerHTML={{__html: shopItem.body}} />
          <div className={`${css['mobile-only']} ${css['scroll-container']}`}>
            <div className={css['modal-title']}>{shopItem.title}</div>
            <div className={css.title}>{shopItem.subtitle}</div>
            <BuyButton
              css={css}
              isDisabled={shopItem.disable}
              identifier={shopItem.identifier}
              isPreorder={shopItem.preorder}
              purchaseIdentifier={shopItem.purchaseIdentifier}
              productData={productData}
              service={service}
              purchaseModalContent={productData.purchaseModalContent}
              ratingsBoard={ratingsBoard} />
          </div>
        </div>
      </div>
    </div>);
  }
}

MoreInfoModal.propTypes = {
  css: PropTypes.object,
  productData: PropTypes.object,
  service: PropTypes.instanceOf(ShopProvider),
  shopItem: PropTypes.object,
  ratingsBoard: PropTypes.object,
  onSale: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/MoreInfoModal.jsx